module.exports = __webpack_public_path__ + "img/section-2-1.5893e27.webp";